import Vue from 'vue'
import VueRouter from 'vue-router'
const PrivacyAgreement=()=>import('../views/privacyAgreement')
const UsersAgreement=()=>import('../views/usersAgreement')
const ChildAgreement=()=>import('../views/childAgreement')
const Home=()=>import('../views/Home')
const InviteFriends=()=>import('../views/inviteFriends')
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
    {
      path: '/user/agreement',
      name: 'UsersAgreement',
      component: UsersAgreement
    },
    {
      path: '/privacy/agreement',
      name: 'PrivacyAgreement',
      component: PrivacyAgreement
    },
    {
      path: '/child/agreement',
      name: 'ChildAgreement',
      component: ChildAgreement
    },
    {
      path: '/invite/friend',
      name: 'InviteFriends',
      component: InviteFriends
    }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
